import { useState } from "react";
import { Link } from "react-router-dom";
import { api, formatApiError } from "../lib/api";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import { toast } from "sonner";
import { ArrowLeft, MailCheck } from "lucide-react";

export function AuthShell({ children }) {
  return (
    <div className="min-h-screen grid place-items-center bg-[#F5F7FB] p-6">
      <div className="w-full max-w-sm panel p-8">{children}</div>
    </div>
  );
}

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [busy, setBusy] = useState(false);
  const [sent, setSent] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try { const { data } = await api.post("/auth/forgot-password", { email }); setSent(data.message); }
    catch (err) { toast.error(formatApiError(err.response?.data?.detail) || "Could not send the reset link"); }
    finally { setBusy(false); }
  };

  return (
    <AuthShell>
      <div className="text-[11px] font-mono uppercase tracking-[0.2em] text-orange-400 mb-2">Account help</div>
      <h2 className="text-2xl font-bold tracking-tight mb-2">Forgot password?</h2>
      {sent ? (
        <div className="space-y-4" data-testid="forgot-sent">
          <div className="flex gap-3 rounded-md border border-emerald-200 bg-emerald-50 p-3 text-sm text-emerald-800">
            <MailCheck className="w-5 h-5 shrink-0" /> {sent}
          </div>
          <Button variant="outline" className="w-full" onClick={() => setSent("")} data-testid="forgot-resend">Send again</Button>
        </div>
      ) : (
        <form onSubmit={submit} className="space-y-4" data-testid="forgot-form">
          <p className="text-sm text-neutral-600">Enter the email you sign in with and we'll email you a link to set a new password.</p>
          <div className="space-y-1.5">
            <Label htmlFor="fp-email" className="text-xs uppercase font-mono tracking-wider text-neutral-600">Email</Label>
            <Input id="fp-email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} data-testid="forgot-email" className="bg-[#FFFFFF] border-[#E4E7EC]" />
          </div>
          <Button type="submit" disabled={busy} className="w-full bg-orange-500 hover:bg-orange-600 text-white" data-testid="forgot-submit">
            {busy ? "Sending..." : "Email me a reset link"}
          </Button>
        </form>
      )}
      <Link to="/login" className="mt-6 inline-flex items-center gap-1 text-xs text-neutral-600 hover:text-orange-600" data-testid="back-to-login">
        <ArrowLeft className="w-3.5 h-3.5" /> Back to sign in
      </Link>
    </AuthShell>
  );
}
